<template>
  <div class="navbar-login">
    <div class="buttons">
      <a
        v-if="!account"
        id="blink"
        @click="SignIn"
        target="_blank"
        rel="noopener noreferrer"
        class="btn-log-in-out"
      >
        <font-awesome-icon
          icon="fa-regular fa-user"
          class="tips-icon"
          size="xl"
        />
        Log In</a
      >
      <a
        v-else
        @click="SignOut"
        target="_blank"
        rel="noopener noreferrer"
        class="btn-log-in-out"
      >
        <span class="" v-if="account"> {{ account.name }}</span>
        <font-awesome-icon
          icon="fa-right-from-bracket"
          class="tips-icon q-ml-sm"
          size="xl"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "HeaderLogin",
  inject: ["$msal"],
  data() {
    return {
      account: null,
    };
  },

  async created() {
    if (this.$msal.isAuthenticated) {
      this.account = this.$msal.getActiveAccount();
    }
  },

  methods: {
    ...mapActions({
      setUser: "auth/setUser",
    }),

    async SignIn() {
      await this.$msal
        .signIn()
        .then(async () => {
          const account = await this.$msal.getActiveAccount();
          this.$emitter.emit("login", account);
          this.setUser(account);
          window.location.href = "/";
        })
        .catch((error) => {
          console.error(`error during authentication: ${error}`);
        });
    },
    async SignOut() {
      await this.$msal
        .signOut()
        .then(() => {
          this.account = null;
          this.$emitter.emit("logout", "logging out");
          this.setUser(this.account);
          window.location.href = "/";
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-log-in-out {
  cursor: pointer;
}

#blink {
  -webkit-animation: blink 2s linear infinite;
  animation: blink 2s linear infinite;
  font-weight: 700;
}
@-webkit-keyframes blink {
  50% {
    color: $secondary;
  }
}
@keyframes blink {
  50% {
    color: $secondary;
  }
}
</style>
